/**
 * Rapor yetki yardımcıları — kaynak: bellek cache (RTDB'den hydrate).
 * RTDB boşken / yüklenmeden önce SEED_FALLBACK kullanılır.
 */
import {
  REPORT_KEYS,
  buildSeedPermissions,
  emptyReports,
} from './accessControlConstants'

const SEED_FALLBACK = buildSeedPermissions()

/** @type {Record<string, { email: string, reports: Record<string, boolean> }>} */
let permissionsCache = { ...SEED_FALLBACK }
let cacheFromRtdb = false

export const setPermissionsCache = (permissionsMap, fromRtdb = true) => {
  if (permissionsMap && Object.keys(permissionsMap).length > 0) {
    permissionsCache = { ...permissionsMap }
    cacheFromRtdb = fromRtdb
  } else if (!cacheFromRtdb) {
    permissionsCache = { ...SEED_FALLBACK }
  }
}

export const getPermissionsCache = () => permissionsCache

const normalizeEmail = (userEmail) => String(userEmail || '').trim().toLowerCase()

const getReports = (userEmail) => {
  const email = normalizeEmail(userEmail)
  if (!email) return emptyReports()
  const entry = permissionsCache[email]
  if (!entry?.reports) return emptyReports()
  return { ...emptyReports(), ...entry.reports }
}

export const canAccessReport = (userEmail, reportKey) => {
  if (!userEmail || !reportKey) return false
  return Boolean(getReports(userEmail)[reportKey])
}

export const getUserReportFlags = (userEmail) => getReports(userEmail)

/** Yalnızca Ramak Kala (başka rapor yok) */
export const isRamakKalaOnly = (userEmail) => {
  const r = getReports(userEmail)
  const anyOther =
    r.tesekkur || r.oneritalep || r.sikayet || r.etiklik || r.odul_ik || r.odul_opex
  return Boolean(r.ramakkala) && !anyOther
}

export const isEtikAuthorized = (userEmail) =>
  canAccessReport(userEmail, REPORT_KEYS.ETIKLIK)

export const isRamakKalaAuthorized = (userEmail) =>
  canAccessReport(userEmail, REPORT_KEYS.RAMAKKALA)

export const isOdulOneriIkAuthorized = (userEmail) =>
  canAccessReport(userEmail, REPORT_KEYS.ODUL_IK)

export const isOdulOneriOpexAuthorized = (userEmail) =>
  canAccessReport(userEmail, REPORT_KEYS.ODUL_OPEX)

/** @deprecated NavBar artık canAccessReport kullanır; geriye uyum */
export const isNonEtikAllReportsUser = (userEmail) => {
  const r = getReports(userEmail)
  return (
    (r.tesekkur || r.oneritalep || r.sikayet || r.ramakkala) && !r.etiklik
  )
}

// Eski export isimleri — seed dokümantasyonu / geriye uyum için boş (cache kullanın)
export const ETIK_AUTHORIZED_EMAILS = Object.keys(SEED_FALLBACK).filter(
  (e) => SEED_FALLBACK[e]?.reports?.etiklik
)
export const NON_ETIK_ALL_REPORTS_EMAILS = Object.keys(SEED_FALLBACK).filter(
  (e) => isNonEtikAllReportsUser(e) && !SEED_FALLBACK[e]?.reports?.etiklik
)
export const RAMAKKALA_ONLY_EMAILS = Object.keys(SEED_FALLBACK).filter((e) => {
  const r = SEED_FALLBACK[e]?.reports
  if (!r) return false
  return (
    r.ramakkala &&
    !r.tesekkur &&
    !r.oneritalep &&
    !r.sikayet &&
    !r.etiklik &&
    !r.odul_ik &&
    !r.odul_opex
  )
})
export const ODUL_ONERI_IK_EMAILS = Object.keys(SEED_FALLBACK).filter(
  (e) => SEED_FALLBACK[e]?.reports?.odul_ik
)
export const ODUL_ONERI_OPEX_EMAILS = Object.keys(SEED_FALLBACK).filter(
  (e) => SEED_FALLBACK[e]?.reports?.odul_opex
)
